import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getAlternateLanguageLinks, getCanonicalUrl } from "./seoRoutes";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Oxton Digital",
  url: "https://oxton-digital.com",
  logo: "https://oxton-digital.com/images/oxton.png",
  telephone: "+33 1 73 29 71 53",
  address: {
    "@type": "PostalAddress",
    streetAddress: "214 rue du General Leclerc",
    postalCode: "95120",
    addressLocality: "Ermont",
    addressCountry: "FR",
  },
};

const RouteSeo = () => {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const alternateLinks = getAlternateLanguageLinks(location.pathname);

  return (
    <Helmet prioritizeSeoTags>
      <meta name="robots" content="index,follow" />
      <meta property="og:site_name" content="Oxton Digital" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      {alternateLinks.map((link) => (
        <link key={`${link.hrefLang}:${link.href}`} rel="alternate" hrefLang={link.hrefLang} href={link.href} />
      ))}
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
    </Helmet>
  );
};

export default RouteSeo;
